import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Webhook } from '@app/models/webhook.interface';
import { WebhookHelperService } from '@app/services/helpers/webhook-helper.service';
import { Observable } from 'rxjs';
import { HeadMetaComponent } from "@app/components/head-meta/head-meta.component";
import { LoadingErrorBlockComponent } from "@app/components/loading-error-block/loading-error-block.component";
import { LetDirective } from '@ngrx/component';
import { CreatedUpdatedDisplayComponent } from "@app/components/created-updated-display/created-updated-display.component";
import { DetailDisplayComponent } from "@app/components/detail-display/detail-display.component";
import { faCheck, faPenToSquare, faXmark, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthService } from '@app/services/auth.service';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";
import { DatePipe, JsonPipe } from '@angular/common';
import { WebhookPayloadHelperService } from '@app/services/helpers/webhook-payload-helper.service';
import { WebhookPayload } from '@app/models/webhook-payload.interface';
@Component({
    selector: 'app-webhook-detail',
    templateUrl: './detail.page.html',
    styleUrl: './detail.page.scss',
    imports: [
        HeadMetaComponent,
        LoadingErrorBlockComponent,
        LetDirective,
        CreatedUpdatedDisplayComponent,
        DetailDisplayComponent,
        FontAwesomeModule,
        RouterModule,
        HelpButtonComponent,
        DatePipe,
        JsonPipe
    ]
})
export class WebhookDetailPage {
  title = "Webhook Detail";
  id: number;
  webhook$: Observable<Webhook>;
  webhookPayload$: Observable<WebhookPayload[]>;

  faCheck = faCheck;
  faXmark = faXmark;
  faPenToSquare = faPenToSquare;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private webhookHelper: WebhookHelperService,
    private webhookPayloadHelper: WebhookPayloadHelperService,
    public auth: AuthService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.webhook$ = this.webhookHelper.getById(this.id);
    this.webhookPayload$ = this.webhookPayloadHelper.getByWebhookId(this.id);
  }
}
